/* FileProgressBar styles */
.fileProgressContainer {
  padding: 8px 0;
  border-bottom: 1px solid #e1e1e1;
}

.fileProgressContainer:last-child {
  border-bottom: none;
}

.fileHeader {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 4px;
}

.fileName {
  font-weight: 600;
  font-size: 14px;
  color: #323130;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex: 1;
  margin-right: 8px;
}

.clickableFileName {
  font-weight: 600;
  font-size: 14px;
  color: #323130;
  cursor: pointer;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex: 1;
  margin-right: 8px;
}

.clickableFileName:hover {
  color: #0078d4;
}

.deleteButton {
  background: none;
  border: 1px solid #d13438;
  color: #d13438;
  border-radius: 4px;
  padding: 4px 8px;
  cursor: pointer;
  font-size: 12px;
  font-weight: 500;
  transition: all 0.2s ease;
}

.deleteButton:hover {
  background-color: #d13438;
  color: white;
}

.deleteButton:focus {
  outline: 2px solid #0078d4;
  outline-offset: 2px;
}

.progressDescription {
  font-size: 12px;
  color: #605e5c;
  margin-top: 2px;
}

/* Progress bar color customization */
.progressBarCompleted .ms-ProgressIndicator-progressBar {
  background-color: #107c10 !important;
}

.progressBarError .ms-ProgressIndicator-progressBar {
  background-color: #d13438 !important;
}

.progressBarUploading .ms-ProgressIndicator-progressBar {
  background-color: #0078d4 !important;
}
